// import ApolloClient from 'apollo-client';
import { map } from 'rxjs/operators';
import {
    ApolloClient,
    ApolloLink,
    HttpLink,
    InMemoryCache,
} from '@apollo/client';

const cache = new InMemoryCache();

const errorLink = new ApolloLink((operation, forward) => {
    return forward(operation).pipe(
        map((result) => {
            if (result.errors?.length) {
                result.errors.forEach((err) => console.log(err.message));
            }
            return result;
        })
    );
});

const httpLink = new HttpLink({
    uri: import.meta.env.VITE_GRAPHQL + '/api/graphqlEndpoint',
});

const authLink = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem('accessToken');
    operation.setContext(({ headers = {} }: { headers?: Record<string, string> }) => ({
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    }));
    return forward(operation);
});

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache,
});

export default client;
